export default [
  {
    value: 'title',
    text: 'Заголовок',
    type: 'string',
    description: ''
  },
  {
    value: 'orgType',
    text: 'Тип',
    width: 100,
    type: 'string',
    description: ''
  },
  {
    value: 'surname',
    text: 'Фамилия',
    width: 110,
    type: 'string',
    description: ''
  },
  {
    value: 'name',
    text: 'Имя',
    width: 100,
    type: 'string',
    description: ''
  },
  {
    value: 'patronymic',
    text: 'Отчество',
    width: 110,
    type: 'string',
    description: ''
  },
  {
    value: 'position',
    text: 'Позиция',
    width: 110,
    type: 'string',
    description: ''
  },
  {
    value: 'phone',
    text: 'Телефон',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'email',
    text: 'Email',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'inn',
    text: 'ИНН',
    width: 60,
    type: 'string',
    description: ''
  },
  {
    value: 'ogrn',
    text: 'Номер',
    width: 60,
    type: 'string',
    description: ''
  },
  {
    value: 'legalAddress',
    text: 'Юр. адрес',
    type: 'string',
    description: ''
  },
  {
    value: 'mailAddress',
    text: 'Почтовый адрес',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'bank',
    text: 'Банк',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'checkingAcc',
    text: 'Checking Acc',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'bic',
    text: 'Bic',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
